
import { useState, useEffect, useMemo } from "react";

// react-router components
import { Routes, Route, Navigate, useLocation } from "react-router-dom";

// @mui material components
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import Icon from "@mui/material/Icon";

// Soft UI Dashboard React components
import SoftBox from "components/SoftBox";

// Soft UI Dashboard React examples
import Sidenav from "examples/Sidenav";
import Configurator from "examples/Configurator";
import ConfirmForgotPassword from "layouts/authentication/confirm-forgotpassword";
import Login from "layouts/authentication/sign-in";
import ForgotPassword from "layouts/authentication/forgot-password";
import Resetpassword from "layouts/authentication/reset-password";
import Checkout from "layouts/nbn/checkout";
import PidRegistration from "layouts/Features/PidRegistration";
import NonPidRegistration from "layouts/Features/NonPidRegistration";
import SearchAndAllocateReachargeVoucher from "layouts/Features/SearchAndAllocateReachargeVoucher";
import SearchAndAllocateSimStock from "layouts/Features/SearchAndAllocateSimStock";
import OrderFreeStock from "layouts/Features/OrderFreeStock";
import { AuthProvider } from "utlis/authContext";
import ProtectedRoute from "./protectedRoute";
import NbnPurchase  from "./layouts/nbn/homepage"
import AddPaymentMethod from "layouts/Features/AddPaymentMethod";
import SearchAndAllocatePostPaidSimStock from "layouts/Features/SearchAndAllocatePostpaidSimStock";
import PostPaidSimReplacement from "layouts/Features/PostPaid/PostPaidSimReplacement";


// Soft UI Dashboard React themes
import theme from "assets/theme";
import themeRTL from "assets/theme/theme-rtl";

// RTL plugins
import rtlPlugin from "stylis-plugin-rtl";
import { CacheProvider } from "@emotion/react";
import createCache from "@emotion/cache";

// Soft UI Dashboard React routes
import routes from "routes";

// Soft UI Dashboard React contexts
import { useSoftUIController, setMiniSidenav, setOpenConfigurator } from "context";

// Images
import brand from "assets/images/logo-ct.png";
import MyAccountRegistration from "layouts/Features/MyAccountRegistration";
import DownloadQrCode from "layouts/Features/DownloadQrCode";
import FreeAccessoriesStockAllocation from "layouts/Features/FreeAccessoriesStockAllocation ";
import VoucherQueueing from "layouts/Features/VoucherQueueing";
import SIMReplacement from "layouts/Features/SIMReplacement";
import PrepaidRecharge from "layouts/Features/PrepaidRecharge";
import CreateWorkPlan from "layouts/Features/CreateWorkPlan";
import WorkApproval from "layouts/Features/CreateWorkPlan/WorkApprovals";
import RaiseWorkPlanDeviationRequest from "layouts/Features/CreateWorkPlan/RaiseWorkPlanDeviationRequest";
import ApproveDeviationRequest from "layouts/Features/CreateWorkPlan/ApproveDeviationRequest";
import DailyWorkPlan from "layouts/Features/CreateWorkPlan/DailyWorkPlan/dailyworkplan";
import DailyWorkPlanList from "layouts/Features/CreateWorkPlan/DailyWorkPlanList/dailyworkplanlist";
import EditDailyWorkplan from "layouts/Features/CreateWorkPlan/EditDailyWorkplan/editdailyworkplan";
import ApproveRejectWorkPlan from "layouts/Features/CreateWorkPlan/ApproveRejectWorkPlan/approverejectworkplan";
import RaiseWorkPlanDeviationList from "layouts/Features/CreateWorkPlan/RaiseWorkPlanDeviationList/raiseworkplandeviationlist";
import EditRaiseWorkPlanDeviation from "layouts/Features/CreateWorkPlan/EditRaiseWorkPlanDeviation/editraiseworkplandeviation";
import ContactUs from "layouts/authentication/ContactUs";
import Contact from "layouts/Features/Contact";

import AddMobilePlan from "layouts/Features/AddMobilePlan";
import PrepaidActivation from "layouts/Features/PrepaidActivation";
import WorkApprovalEdit from "layouts/Features/CreateWorkPlan/WorkApprovalEdit/workapprovaledit";
import MyWorkPlanInfo from "layouts/Features/CreateWorkPlan/MyWorkPlanInfo/myworkplaninfo";
import MyWorkPlanInfoEdit from "layouts/Features/CreateWorkPlan/MyWorkPlanInfoEdit/myworkplaninfoedit";
import MyWorkPlanDevitionRequestEdit from "layouts/Features/CreateWorkPlan/MyWorkPlanDevitionRequestEdit/myworkplandevitionrequestedit";
import ApproveDeviationRequestEdit from "layouts/Features/CreateWorkPlan/ApproveDeviationRequestEdit/approvedeviationrequestedit";
import MyWorkPlanDevitionRequestInfo from "layouts/Features/CreateWorkPlan/MyWorkPlanDevitionRequestInfo/myworkplandevitionrequestinfo";

import InternationalEsim from "layouts/Features/InternationalEsim";
import CountryPlanLIst from "layouts/Features/InternationalEsim/CountryPlanLIst";
import RegionPlanList from "layouts/Features/InternationalEsim/RegionPlanList";
import PlanDetailsCard from "layouts/Features/InternationalEsim/PlanDetailsCard";
import CustomerRegistration from "layouts/Features/InternationalEsim/CustomerRegistraion";
import OrderConfirmation from "layouts/Features/InternationalEsim/OrderConfirmation";
import OrderCheckout from "layouts/Features/InternationalEsim/OrderCheckout";
import PurchasePhysicalRechargeVouchers from "layouts/Features/PurchasePhysicalRechargeVouchers";
import WalletCredits from "layouts/Features/WalletCredits";
import EsimSupportingDevices from "layouts/Features/EsimSupportngDevices";
import MyDailyWorkPlanEdit from "layouts/Features/CreateWorkPlan/MyDailyWorkPlanEdit/mydailyworkplanedit";
import MyDailyWorkPlanList from "layouts/Features/CreateWorkPlan/MyDailyWorkPlanList/mydailyworkplanlist";
import VideoTutorials from "layouts/Features/VideoTutorials";
import TelsimStockRequest from "layouts/Features/TelsimStockRequest";
import OnHoldQuantityUpdate from "layouts/authentication/OnHoldQuantityUpdate";
import PremiumNumbers from "layouts/Features/PremiumNumbers";
import ReferAndEarn from "layouts/Features/ReferAndEarn";
import PostPaidActivation from "layouts/Features/PostPaidActivation";

import DownloadPostPaidQrCode from "layouts/Features/PostPaid/DownloadeSIMQrcode";
import CommonDownloadQrCode from "layouts/Features/CommonDownloadQrCode";
import CommonSIMReplacement from "layouts/Features/CommonSIMReplacement"
import SimOnlyTutorial   from "layouts/Features/SimOnlyTutorialVideo"
import SearchAndReturnSimStock from "layouts/Features/SearchAndReturnSimStock";


// wme routes

import WmePrepaidActivation from "layouts/Features/WME/Activation/PrepaidActivation"
import WmeAddMobilePlan from "layouts/Features/WME/AddaMobileplan"



// wme routes





export default function App() {
  const [controller, dispatch] = useSoftUIController();
  const { miniSidenav, direction, layout, openConfigurator, sidenavColor } = controller;
  const [onMouseEnter, setOnMouseEnter] = useState(false);
  const [rtlCache, setRtlCache] = useState(null);
  const { pathname } = useLocation();

  // Cache for the rtl
  useMemo(() => {
    const cacheRtl = createCache({
      key: "rtl",
      stylisPlugins: [rtlPlugin],
    });

    setRtlCache(cacheRtl);
  }, []);

  // Open sidenav when mouse enter on mini sidenav
  const handleOnMouseEnter = () => {
    if (miniSidenav && !onMouseEnter) {
      setMiniSidenav(dispatch, false);
      setOnMouseEnter(true);
    }
  };

  useEffect(()=>{
    if(innerWidth<1200){
      setMiniSidenav(dispatch, true);
    }
  },[])

  // Close sidenav when mouse leave mini sidenav
  const handleOnMouseLeave = () => {
    if (onMouseEnter) {
      setMiniSidenav(dispatch, true);
      setOnMouseEnter(false);
    }
  };

  // Change the openConfigurator state
  const handleConfiguratorOpen = () => setOpenConfigurator(dispatch, !openConfigurator);

  // Setting the dir attribute for the body element
  useEffect(() => {
    document.body.setAttribute("dir", direction);

    
  }, [direction]);

  // Setting page scroll to 0 when changing the route
  useEffect(() => {
    document.documentElement.scrollTop = 0;
    document.scrollingElement.scrollTop = 0;
  }, [pathname]);

  const getRoutes = (allRoutes) =>
    allRoutes.map((route) => {
      if (route.collapse) {
        return getRoutes(route.collapse);
      }

      if (route.route) {
        return <Route exact path={route.route} element={route.component} key={route.key} replace={true} />;
      }

      return null;
    });

  const configsButton = (
    <SoftBox
      display="flex"
      justifyContent="center"
      alignItems="center"
      width="3.5rem"
      height="3.5rem"
      bgColor="white"
      shadow="sm"
      borderRadius="50%"
      position="fixed"
      right="2rem"
      bottom="2rem"
      zIndex={99}
      color="dark"
      sx={{ cursor: "pointer" }}
      onClick={handleConfiguratorOpen}
    >
      <Icon fontSize="default" color="inherit">
        settings
      </Icon>
    </SoftBox>
  );

  return direction === "rtl" ? (
    <CacheProvider value={rtlCache}>
      <ThemeProvider theme={themeRTL}>
        <CssBaseline />
        {layout === "dashboard" && (
          <>
            <Sidenav
              color={sidenavColor}
              brand={brand}
              brandName="Soft UI Dashboard"
              routes={routes}
              onMouseEnter={handleOnMouseEnter}
              onMouseLeave={handleOnMouseLeave}
            />
            <Configurator />
            
          </>
        )}
        {layout === "vr" && <Configurator />}
        <Routes>
          {getRoutes(routes)}
          <Route path="*" element={<Navigate to="/dashboard" />} />

        </Routes>
      </ThemeProvider>
    </CacheProvider>
  ) : (
    <AuthProvider>
    <ThemeProvider theme={theme}>
      <CssBaseline />
      {layout === "dashboard" && (
        <>
          <Sidenav
            color={sidenavColor}
            brand={brand}
            brandName="Soft UI Dashboard"
            routes={routes}
            onMouseEnter={handleOnMouseEnter}
            onMouseLeave={handleOnMouseLeave}
          />
          <Configurator />
         
        </>
      )}
      {/* {layout === "vr" && <Configurator />} */}
      <Routes>
        {getRoutes(routes)}



        <Route path="*" element={<Navigate to="/login" />} />
        <Route path="/forgotpassword" element={<ForgotPassword/>} /> 
        <Route path="/confirm-forgotpassword" element={<ConfirmForgotPassword/>} /> 
       <Route path="/login" element={<Login/>} /> 
       <Route path="/reset-password" element={<Resetpassword/>} /> 
       <Route path="/checkout" element={<Checkout/>} /> 
        <Route  path="/pid-registration" element={<PidRegistration/>}/>
       <Route  path="/non-pid-registration" element={<NonPidRegistration/>}/> 
       {/* <Route path="/allocate-sim-stock" element={<SearchAndAllocateSimStock/>}/> */}
       <Route path="/allocate-recharge-voucher" element={< SearchAndAllocateReachargeVoucher/>}/>
       <Route path="/register_telsim_myaccount" element={< MyAccountRegistration/>}/>
       <Route path="/sim_replacement_request" element={<SIMReplacement />}/>
       <Route path="/download_esim_qr_code" element={< DownloadQrCode/>}/>
       <Route path="/recharge_voucher_queueing" element={<VoucherQueueing/>}/>
       <Route path="/free_accessories_stock_allocation" element={< FreeAccessoriesStockAllocation/>}/>
       <Route path="/add_a_prepaid_plan_me" element={< AddMobilePlan/>}/>
       <Route path="/activate_prepaid_plan_me" element={< PrepaidActivation/>}/>
       <Route path="/contact_us" element={<ContactUs/>}/>
       <Route path="/contact-us" element={<Contact/>}/>
       <Route path="/onhold-quantity-update/:id" element={<OnHoldQuantityUpdate/>}/>

       
       <Route path="/prepaid_recharge" element={< PrepaidRecharge/>}/>
       <Route path="/add_payment_method" element={<AddPaymentMethod/>}/>


       {/* International Esim activation  */}
       <Route path="/activate_travel_esim" element={<InternationalEsim/>} replace={true}/>
       <Route path="/activate_travel_esim/country_wise_plans" element={<CountryPlanLIst/>}/>
       <Route path="/activate_travel_esim/region_wise_plans" element={<RegionPlanList/>}/>
       {/* <Route path="/international_esim/customer_registration" element={<CustomerRegistration/>}/> */}
       <Route path="/international_esim/order-confirmation" element={<OrderConfirmation/>}/>
       <Route path="/activate_travel_esim/order-checkout" element={<OrderCheckout/>}/>


       {/* <Route path="/international_esim/plan_details" element={<PlanDetailsCard/>}/> */}


       <Route path="/create_work_plan" element={< CreateWorkPlan/>}/>
       {/* <Route path="/work_approval" element={< WorkApproval/>}/> */}
       <Route path="/approve_work_plan" element={< WorkApproval/>}/>
       <Route path="/create_work_plan_deviation" element={< RaiseWorkPlanDeviationRequest/>} />
       <Route path="/approve_work_plan_deviation" element={< ApproveDeviationRequest/>} />
       <Route path="/update_my_daily_work" element={ <DailyWorkPlan/>} />
       <Route path="/approve_daily_work" element={ <DailyWorkPlanList/> } />

       <Route path="/edit_daily_work_plan" element={ <EditDailyWorkplan/> } />
       <Route path="/approve_reject_work_plan" element={ <ApproveRejectWorkPlan /> } />
       <Route path="/raise_work_plan_deviation_list" element={ <RaiseWorkPlanDeviationList />} />
       <Route path="/work_approval_edit" element={< WorkApprovalEdit /> } />
       <Route path="/purchase_physical_recharge_voucher" element={<PurchasePhysicalRechargeVouchers/> } />
       <Route path="/wallet" element={<WalletCredits/> } />
       <Route path="/esim_supporting_devices" element={<EsimSupportingDevices/> } />
       <Route path="/list_my_work_plan" element={< MyWorkPlanInfo />} />
       <Route path="/my_work_plan_info_edit" element={ < MyWorkPlanInfoEdit /> } />
       <Route path="/approve_deviation_request_edit" element={ < ApproveDeviationRequestEdit/>} />
       <Route path="/list_my_work_plan_deviation" element={ < MyWorkPlanDevitionRequestInfo/>} />
       <Route path="/my_work_plan_deviation_request_edit" element={ < MyWorkPlanDevitionRequestEdit/>} />
       <Route path="/edit_raise_work_plan_deviationlist" element={ <EditRaiseWorkPlanDeviation /> } />
       {/* < protectedRoute path="/NBN-Purchase"  element={<NbnPurchase/>}/> */}
       {/* <Route path="/purchase-nbn" element={<Resetpassword/>} />  */}
       <Route path="/purchase_physical_recharge_voucher" element={<PurchasePhysicalRechargeVouchers/> } />
       <Route path="/esim_supporting_devices" element={<EsimSupportingDevices/> } />
       <Route path="/list_my_daily_work" element={ <MyDailyWorkPlanList/> } />      
       <Route path="/my_daily_work_plan_edit" element={ <MyDailyWorkPlanEdit/> } />  
       <Route path="/video_tutorials" element={<VideoTutorials/> } />
       <Route path="/order_sim_stocks" element={< OrderFreeStock/>}/>
       {/* <Route path="/premium_numbers" element={<PremiumNumbers/>}/> */}
       <Route path="/refer_and_earn" element={<ReferAndEarn/>}/>
       <Route path="/allocate_sim_stock_sim_only" element={<SearchAndAllocatePostPaidSimStock/>}/>
      <Route path="/download_esim_qr_code_sim_only" element={< DownloadPostPaidQrCode/>}/>
      <Route path="/sim_only_activation" element={<PostPaidActivation/>}/>
       <Route path="/sim_replacement_sim_only" element={<PostPaidSimReplacement/>}/>
       <Route path="/stock_request" element={<TelsimStockRequest/>}/>
       <Route path="/return_old_sim_stock" element={<SearchAndReturnSimStock/>}/>



       <Route path="/common_download_esim_qr_code" element={<CommonDownloadQrCode/>}/>
       <Route path="/common_sim_replacement" element={<CommonSIMReplacement />}/>
       <Route path="/common_register_myaccount" element={< MyAccountRegistration/>}/>
       <Route path="/sim_only_video" element={< SimOnlyTutorial/>}/>


       {/*Wme Routes */}

       <Route path="/activate_prepaid_plan" element={<WmePrepaidActivation/>}/>
       <Route path="/add_a_prepaid_plan" element={<WmeAddMobilePlan/>}/>
                        
    
       {/*Wme Routes */}

        


      

        








      
      </Routes>
    </ThemeProvider>
    </AuthProvider>
  );
}
